'use strict';

var i18n = require('i18next');
var EditDescription = require('actions/description/dna/EditDescription');
var FormView = require('actions/description/FormView');
var StaticView = require('actions/description/StaticView');

/**
 * Action configuration for the DNA Description action component.
 */
module.exports = {
  title: i18n.t('actionDescription.description'),
  Model: EditDescription,
  FormView: FormView,
  TextView: StaticView,
};
